import { render, staticRenderFns } from "./LoadingIcon.vue?vue&type=template&id=0194d0a6&scoped=true&"
var script = {}
import style0 from "./LoadingIcon.vue?vue&type=style&index=0&id=0194d0a6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0194d0a6",
  null
  
)

export default component.exports